/* RV Custom — minimale theme JS (skeleton). Mobile-first interacties. */
(function () {
  document.documentElement.classList.remove('no-js');

  // ===== Winkelwagen-lade (cart drawer) =====
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartOverlay = document.querySelector('[data-cart-overlay]');
  var cartTimerInt = null;

  function fmtTime(s) { var m = Math.floor(s / 60), ss = s % 60; return m + ':' + (ss < 10 ? '0' + ss : ss); }

  function startCartTimer() {
    if (!cartDrawer) return;
    var bar = cartDrawer.querySelector('[data-cart-timer-bar]');
    var out = cartDrawer.querySelector('[data-cart-timer]');
    if (!bar || !out) return;
    var dur = (parseInt(bar.getAttribute('data-minutes'), 10) || 6) * 60;
    var nowS = function () { return Math.floor(Date.now() / 1000); };
    var end = parseInt(sessionStorage.getItem('rvCartTimerEnd'), 10);
    if (!end || end <= nowS()) { end = nowS() + dur; sessionStorage.setItem('rvCartTimerEnd', end); }
    function tick() {
      var left = end - nowS();
      if (left <= 0) { end = nowS() + dur; sessionStorage.setItem('rvCartTimerEnd', end); left = dur; }
      out.textContent = fmtTime(left);
    }
    if (cartTimerInt) clearInterval(cartTimerInt);
    tick();
    cartTimerInt = setInterval(tick, 1000);
  }

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    startCartTimer();
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  function applyCartSection(html) {
    if (!html || !cartDrawer) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cart-drawer-contents]');
    var live = cartDrawer.querySelector('[data-cart-drawer-contents]');
    if (fresh && live) {
      live.innerHTML = fresh.innerHTML;
      var c = fresh.getAttribute('data-count');
      if (c != null) document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = c; });
    }
  }
  function cartAdd(id, qty) {
    // Accepteert één variant-id of een array items [{id, quantity}] (bundel-widget).
    var items = Array.isArray(id) ? id : [{ id: id, quantity: qty || 1 }];
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items, sections: ['cart-drawer'], sections_url: window.location.pathname })
    }).then(function (r) { if (!r.ok) throw new Error('add-failed'); return r.json(); })
      .then(function (res) { applyCartSection(res.sections && res.sections['cart-drawer']); return res; });
  }
  // Haalt de actuele drawer-inhoud opnieuw van de server (om na een mislukte wijziging te hersyncen)
  function refreshCartDrawer() {
    return fetch(window.location.pathname + '?sections=cart-drawer', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (res) { if (res) applyCartSection(res['cart-drawer']); })
      .catch(function () {});
  }
  function cartChange(line, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, sections: ['cart-drawer'], sections_url: window.location.pathname })
    }).then(function (r) { if (!r.ok) throw new Error('change-failed'); return r.json(); })
      .then(function (cart) { applyCartSection(cart.sections && cart.sections['cart-drawer']); return cart; });
  }
  window.RVCart = { open: openCart, close: closeCart, add: cartAdd, change: cartChange };

  function lineQtyFromBtn(btn) {
    var item = btn.closest('[data-cart-item]');
    var v = item && item.querySelector('.qty-selector__val');
    return v ? (parseInt(v.textContent, 10) || 0) : 0;
  }
  if (cartDrawer) {
    document.querySelectorAll('[data-cart-toggle]').forEach(function (t) {
      t.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
    });
    if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
    cartDrawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-close]')) { closeCart(); return; }
      var up = e.target.closest('[data-qty-up]');
      var down = e.target.closest('[data-qty-down]');
      var rem = e.target.closest('[data-cart-remove]');
      if (up) { cartChange(parseInt(up.getAttribute('data-qty-up'), 10), lineQtyFromBtn(up) + 1).catch(refreshCartDrawer); }
      else if (down) { cartChange(parseInt(down.getAttribute('data-qty-down'), 10), Math.max(0, lineQtyFromBtn(down) - 1)).catch(refreshCartDrawer); }
      else if (rem) { cartChange(parseInt(rem.getAttribute('data-cart-remove'), 10), 0).catch(refreshCartDrawer); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });
  }

  // Sale-countdown — telt af tot vandaag 23:59:59 (dagelijkse reset)
  var countdownEls = document.querySelectorAll('[data-countdown]');
  if (countdownEls.length) {
    var pad2 = function (n) { return n < 10 ? '0' + n : '' + n; };
    var tickCountdown = function () {
      var now = new Date();
      var end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
      var diff = Math.floor((end - now) / 1000);
      if (diff < 0) diff = 0;
      var txt = pad2(Math.floor(diff / 3600)) + ':' + pad2(Math.floor((diff % 3600) / 60)) + ':' + pad2(diff % 60);
      countdownEls.forEach(function (el) { el.textContent = txt; });
    };
    tickCountdown();
    setInterval(tickCountdown, 1000);
  }

  // Aankondigingsbalk — handmatig wisselen tussen punten (geen auto-scroll)
  var announce = document.querySelector('[data-announcement]');
  if (announce) {
    var aSlides = announce.querySelectorAll('[data-announce-slide]');
    if (aSlides.length > 1) {
      var aIdx = 0;
      var aShow = function (i) {
        aIdx = (i + aSlides.length) % aSlides.length;
        aSlides.forEach(function (s, j) { s.classList.toggle('is-active', j === aIdx); });
      };
      var aPrev = announce.querySelector('[data-announce-prev]');
      var aNext = announce.querySelector('[data-announce-next]');
      if (aPrev) aPrev.addEventListener('click', function () { aShow(aIdx - 1); });
      if (aNext) aNext.addEventListener('click', function () { aShow(aIdx + 1); });
    }
  }

  // Hero slideshow — auto-rotatie + dot-navigatie
  var hero = document.querySelector('[data-hero-slideshow]');
  if (hero) {
    var slides = hero.querySelectorAll('[data-hero-slide]');
    var dots = hero.querySelectorAll('[data-hero-dot]');
    if (slides.length > 1) {
      var idx = 0;
      var seconds = parseInt(hero.getAttribute('data-autoplay'), 10) || 0;
      var timer;
      var go = function (i) {
        idx = (i + slides.length) % slides.length;
        slides.forEach(function (s, j) { s.classList.toggle('is-active', j === idx); });
        dots.forEach(function (d, j) { d.classList.toggle('is-active', j === idx); });
      };
      var restart = function () { if (seconds > 0) { clearInterval(timer); timer = setInterval(function () { go(idx + 1); }, seconds * 1000); } };
      dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-hero-dot'), 10)); restart(); }); });
      restart();
    }
  }

  // Mobiel slide-in menu (drawer + overlay + scroll-lock)
  var burger = document.querySelector('[data-menu-toggle]');
  var drawer = document.querySelector('[data-menu-drawer]');
  var overlay = document.querySelector('[data-menu-overlay]');
  var closeBtn = document.querySelector('[data-menu-close]');
  function openMenu() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.hidden = false;
    if (burger) burger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.hidden = true;
    if (burger) burger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }
  if (burger) burger.addEventListener('click', openMenu);
  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  if (overlay) overlay.addEventListener('click', closeMenu);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenu(); });

  // Gallery thumbnails → scroll bijbehorende media in beeld + active state
  var gallery = document.querySelector('.product__media-gallery');
  var thumbs = document.querySelectorAll('.product__thumbnail');
  if (gallery && thumbs.length) {
    var items = gallery.querySelectorAll('.product__media-item');
    // Eén helper voor alle scroll-naar-media (thumbs, dots, pijlen); active-state volgt via de scroll-sync
    var goToMedia = function (idx) {
      var target = items[idx];
      if (target) gallery.scrollTo({ left: target.offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
    };
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = parseInt(t.getAttribute('data-thumb-index'), 10);
        goToMedia(i);
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
    // Dots (mobiel, overlay ín de foto) — zelfde gedrag als de thumbs
    var mediaDots = document.querySelectorAll('.product__media-dot');
    mediaDots.forEach(function (d) {
      d.addEventListener('click', function () {
        var i = parseInt(d.getAttribute('data-media-dot'), 10);
        goToMedia(i);
        mediaDots.forEach(function (x, j) { x.classList.toggle('is-active', j === i); });
      });
    });
    // active thumb + dot volgen scroll van de gallery
    var sync = function () {
      var idx = Math.round(gallery.scrollLeft / gallery.clientWidth);
      thumbs.forEach(function (x, j) { x.classList.toggle('is-active', j === idx); });
      mediaDots.forEach(function (x, j) { x.classList.toggle('is-active', j === idx); });
    };
    gallery.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });

    // Vorige/volgende-pijlen op de hoofdfoto
    var prevBtn = document.querySelector('[data-media-prev]');
    var nextBtn = document.querySelector('[data-media-next]');
    var step = function (dir) {
      var idx = Math.round(gallery.scrollLeft / gallery.clientWidth) + dir;
      idx = Math.max(0, Math.min(items.length - 1, idx));
      goToMedia(idx);
    };
    if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });
  }

  // Variant picker: update hidden id + selected label + prijs + ATC state
  var form = document.getElementById('product-form');
  if (form) {
    var root = form.closest('product-info') || document;
    var variants = [];
    try {
      var vEl = root.querySelector('script[data-variants]');
      if (vEl) variants = JSON.parse(vEl.textContent);
    } catch (e) {}
    var hiddenId = form.querySelector('[data-variant-id]');
    var atc = form.querySelector('.button--atc');
    // Knoptekst uit het data-attribuut zodat de sectie-instelling atc_label ook na een variantwissel geldt
    var atcLabel = (atc && atc.getAttribute('data-atc-label')) || 'AJOUTER AU PANIER';
    // Eén plek voor de koopknop-status (hoofd + sticky): disabled + label/Vypredané
    function setAtcState(btn, available) {
      if (!btn) return;
      btn.disabled = !available;
      var sp = btn.querySelector('span') || btn;
      sp.textContent = available ? (btn.getAttribute('data-atc-label') || atcLabel) : 'Épuisé';
    }
    var priceEl = root.querySelector('.f-price-item--regular');
    var fieldsets = form.querySelectorAll('fieldset.product-form__input');

    function selectedOptions() {
      var vals = [];
      fieldsets.forEach(function (fs) {
        var checked = fs.querySelector('input[type="radio"]:checked');
        if (checked) vals.push(checked.value);
      });
      return vals;
    }
    // Eén plek voor het visueel markeren van de gekozen swatch (hoofd-picker én sticky-sync)
    function markSelected(radio) {
      var fieldset = radio.closest('fieldset');
      if (!fieldset) return;
      fieldset.querySelectorAll('.variant-swatch').forEach(function (s) { s.classList.remove('is-selected'); });
      var lbl = radio.closest('.variant-swatch') || fieldset.querySelector('label[for="' + radio.id + '"]');
      if (lbl) lbl.classList.add('is-selected');
      var legendSel = fieldset.querySelector('[data-selected-swatch-value]');
      if (legendSel) legendSel.textContent = radio.value;
    }
    var galleryEl = document.querySelector('.product__media-gallery');
    var stickyBar = document.querySelector('[data-sticky-atc]');
    var stickySelect = stickyBar && stickyBar.querySelector('[data-sticky-variant]');
    var stickyAdd = stickyBar && stickyBar.querySelector('[data-sticky-add]');
    // Per optie-waarde bepalen of de combinatie bestaat/leverbaar is.
    // Niet-bestaand -> verbergen, uitverkocht -> doorstrepen (geport uit het referentiethema).
    function refreshVariantStates() {
      if (!variants.length) return;
      var sel = selectedOptions();
      fieldsets.forEach(function (fs, i) {
        fs.querySelectorAll('input[type="radio"]').forEach(function (radio) {
          var exists = false, available = false;
          variants.forEach(function (v) {
            if (v.options[i] !== radio.value) return;
            var match = true;
            for (var k = 0; k < sel.length; k++) {
              if (k !== i && v.options[k] !== sel[k]) { match = false; break; }
            }
            if (match) { exists = true; if (v.available) available = true; }
          });
          var label = fs.querySelector('label[for="' + radio.id + '"]');
          if (!label) return;
          label.classList.toggle('is-hidden', !exists);
          label.classList.toggle('is-soldout', exists && !available);
        });
      });
    }
    refreshVariantStates();

    function update() {
      refreshVariantStates();
      var sel = selectedOptions();
      var match = variants.find(function (v) {
        return v.options.length === sel.length && v.options.every(function (o, i) { return o === sel[i]; });
      });
      if (!match) {
        // Onbestaande optiecombinatie: koopknop blokkeren + hidden id wissen zodat niet stilzwijgend de vorige variant wordt gekocht
        setAtcState(atc, false);
        setAtcState(stickyAdd, false);
        if (hiddenId) hiddenId.value = '';
        return;
      }
      if (hiddenId) hiddenId.value = match.id;
      if (priceEl && match.price) priceEl.textContent = match.price;
      // Besparing en doorgestreepte prijs: verbergen als de gekozen variant geen korting heeft (anders blijft oude claim staan)
      var savWrap = root.querySelector('[data-savings]');
      if (savWrap) savWrap.style.display = match.savings == null ? 'none' : '';
      var savEl = root.querySelector('[data-savings-amount]'); if (savEl && match.savings != null) savEl.textContent = match.savings;
      var cmpWrap = root.querySelector('.f-price-item--compare');
      if (cmpWrap) cmpWrap.style.display = match.compare == null ? 'none' : '';
      var cmpEl = root.querySelector('.f-price-item--compare s'); if (cmpEl && match.compare != null) cmpEl.textContent = match.compare;
      setAtcState(atc, match.available);
      // Verzendregel, lage-voorraad en urgentie-nota horen alleen bij een leverbare variant
      var shipEl = root.querySelector('.product-shipline');
      if (shipEl) shipEl.style.display = match.available ? '' : 'none';
      var lowEl = root.querySelector('.product-lowstock');
      if (lowEl) lowEl.style.display = match.available ? '' : 'none';
      var urgEl = root.querySelector('.coupon-box');
      if (urgEl) { var urgBlock = urgEl.closest('.product__block') || urgEl; urgBlock.style.display = match.available ? '' : 'none'; }
      // Hoofdfoto wisselen naar de gekozen variant (kleur staat bij de foto)
      if (match.media != null && galleryEl) {
        var targetItem = galleryEl.querySelector('.product__media-item[data-media-id="' + match.media + '"]');
        if (targetItem) {
          galleryEl.scrollTo({ left: targetItem.offsetLeft - galleryEl.offsetLeft, behavior: 'smooth' });
          document.querySelectorAll('.product__thumbnail').forEach(function (t) {
            t.classList.toggle('is-active', t.getAttribute('data-media-id') === String(match.media));
          });
        }
      }
      // Sticky-balk synchroniseren met de gekozen variant
      if (stickySelect) stickySelect.value = match.id;
      setAtcState(stickyAdd, match.available);
    }

    form.querySelectorAll('input[type="radio"]').forEach(function (r) {
      r.addEventListener('change', function () {
        markSelected(r);
        update();
      });
    });

    // AJAX add-to-cart → opent de winkelwagen-lade
    if (atc) {
      form.addEventListener('submit', function (e) {
        if (form.hasAttribute('data-bundle-mode')) return; // bundel-widget regelt de submit zelf
        e.preventDefault();
        if (atc.disabled || atc.classList.contains('is-loading')) return;
        var span = atc.querySelector('span') || atc;
        var label = span.textContent;
        atc.classList.add('is-loading');
        atc.setAttribute('aria-busy', 'true');
        span.textContent = 'Ajout en cours…';
        var id = (hiddenId && hiddenId.value) || (form.querySelector('[name="id"]') || {}).value;
        window.RVCart.add(id, 1)
          .then(function () {
            atc.classList.remove('is-loading');
            atc.removeAttribute('aria-busy');
            span.textContent = label;
            window.RVCart.open();
          })
          .catch(function () {
            atc.classList.remove('is-loading');
            atc.removeAttribute('aria-busy');
            span.textContent = 'Reintentar';
            setTimeout(function () { span.textContent = label; }, 2000);
          });
      });
    }

    // Sticky add-to-cart: variant-sync, klik, en zichtbaar maken bij scrollen
    if (stickyBar) {
      if (stickySelect) {
        stickySelect.addEventListener('change', function () {
          var v = variants.find(function (x) { return String(x.id) === String(stickySelect.value); });
          if (!v) return;
          // Zet de bijbehorende radio's terug in de hoofd-picker, zodat alles meebeweegt
          fieldsets.forEach(function (fs, i) {
            var radios = fs.querySelectorAll('input[type="radio"]');
            radios.forEach(function (radio) {
              if (radio.value === v.options[i]) {
                radio.checked = true;
                markSelected(radio);
              }
            });
          });
          update();
        });
      }
      if (stickyAdd) {
        stickyAdd.addEventListener('click', function () {
          if (stickyAdd.disabled) return;
          if (form.hasAttribute('data-bundle-mode')) {
            // Bundel-modus: de sticky-balk toont één variant, dus voeg bewust 1 stuk toe (de staffel geldt alleen via de bundel-widget zelf)
            var sid = (stickySelect && stickySelect.value) || (hiddenId && hiddenId.value);
            if (sid) { window.RVCart.add(parseInt(sid, 10), 1).then(function () { window.RVCart.open(); }).catch(function () {}); }
            return;
          }
          if (typeof form.requestSubmit === 'function') form.requestSubmit();
          else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        });
      }
      var buyBlock = form.querySelector('.product__block--buy_buttons') || atc;
      if (buyBlock && 'IntersectionObserver' in window) {
        stickyBar.hidden = false;
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            // Toon de balk zodra de hoofd-ATC uit beeld is
            stickyBar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
          });
        }, { threshold: 0 });
        io.observe(buyBlock);
      }
    }
  }

  // Slideshow met tekst — dots volgen scroll + klik + optioneel autoplay
  document.querySelectorAll('[data-slides]').forEach(function (slideshow) {
    var track = slideshow.querySelector('[data-slides-track]');
    var dots = slideshow.querySelectorAll('[data-slides-dot]');
    if (!track) return;
    var slides = track.querySelectorAll('[data-slide]');
    if (slides.length < 2) return;
    var current = 0;
    function goTo(i) {
      current = (i + slides.length) % slides.length;
      var target = slides[current];
      track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
    dots.forEach(function (d) {
      d.addEventListener('click', function () { goTo(parseInt(d.getAttribute('data-slides-dot'), 10)); restart(); });
    });
    var syncDots = function () {
      var idx = Math.round(track.scrollLeft / track.clientWidth);
      current = Math.max(0, Math.min(slides.length - 1, idx));
      dots.forEach(function (x, j) { x.classList.toggle('is-active', j === current); });
    };
    track.addEventListener('scroll', function () { window.requestAnimationFrame(syncDots); }, { passive: true });
    var secs = parseInt(slideshow.getAttribute('data-autoplay'), 10) || 0;
    var timer;
    function restart() { if (secs > 0) { clearInterval(timer); timer = setInterval(function () { goTo(current + 1); }, secs * 1000); } }
    restart();
  });
})();

/* Recently viewed: producthandle bijhouden in localStorage (max 12, nieuwste eerst) */
(function () {
  var recentRoot = document.querySelector('product-info[data-product-handle]');
  if (!recentRoot) return;
  try {
    var rvKey = 'aj-recent-products';
    var rvHandle = recentRoot.getAttribute('data-product-handle');
    if (!rvHandle) return;
    var rvList = JSON.parse(localStorage.getItem(rvKey) || '[]');
    rvList = rvList.filter(function (h) { return h !== rvHandle; });
    rvList.unshift(rvHandle);
    localStorage.setItem(rvKey, JSON.stringify(rvList.slice(0, 12)));
  } catch (e) {}
})();
